<template>
<div class="public-toast">
  <div class="toast-content">
    <img class="add-shop-cart-icon" src="/clientmodule/distVueCli/newHomeVue/img/addcart_succ_icon.png" />
    <div>{{publicToast.text}}</div>
  </div>
</div>
</template>

<script>
import axios from 'axios';
export default { 
  name: 'PublicToast',
  data() {
    return {
      clearTimer: ''
    }
  },
  components: {
  },
  created() {
    
  },
  mounted() {
  },
  watch: {
    publicToastRecord: function () {
      var self = this
      clearTimeout(self.clearTimer)
      self.clearTimer = setTimeout(() => {
        self.$store.commit('setPublicToast',{
          show: false,
          type: 'addShopcart',
          text: '添加成功，在购物车等亲~'
        });
      }, 2500);
    }
  },
  computed: {
    publicToastRecord: function(){
      return this.$store.state.home.publicToastRecord
    },
    publicToast: function(){
      return this.$store.state.home.publicToast
    }
  },
  methods: {
    
  }
}
</script>

<style scoped>
.public-toast{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9;
  display: flex;
  justify-content: center;
  align-items: center
}
.toast-content{
  background: #000;
  color: #fff;
  font-size: 14px;
  border-radius: 6px;
  padding: 18px 16px 14px;
  text-align: center
}
.add-shop-cart-icon{
  width: 36px;
  padding-bottom: 18px
}
</style>